import { SvgIcon, SxProps } from "@mui/material";
import ReactionAngrySvg from "jsx:../../../Images/Icons/Custom/reactionAngry.svg";

export function ReactionAngryIcon(props: SxProps) {
    return <SvgIcon component={ReactionAngrySvg} inheritViewBox sx={props} />;
}
